import type { CellGridId } from "./stackClient";

/*
 *
 * When the capture cannot be shown to match the loaded grid, the tunables (layers, weights, k
 * breaks, target) still restore and only the per-cell edits are dropped: losing hand edits is
 * recoverable, painting the wrong acres is not.
 */
export function overridesFor(
  cap: { grid?: CellGridId | null; overrides: [number, number][] },
  grid: CellGridId | null,
): Map<number, number> {
  const ok =
    cap.grid != null &&
    grid != null &&
    cap.grid.contentVersion === grid.contentVersion &&
    cap.grid.n === grid.n;
  if (!ok && cap.overrides.length) {
    console.warn(
      `[zoneEdit] ${cap.overrides.length} hand-edited cell(s) were NOT restored: they were made against a different ` +
        `cell grid (${cap.grid ? `${cap.grid.contentVersion}/${cap.grid.n}` : "unrecorded"} vs ` +
        `${grid ? `${grid.contentVersion}/${grid.n}` : "unknown"}). Re-apply them on the current map.`,
    );
  }
  return ok ? new Map(cap.overrides) : new Map();
}

/* * Manual brush edits win over the engine's labels. An empty override map returns the engine list. */
export function labelsWithOverrides(
  computed: number[],
  overrides: Map<number, number>,
): number[] {
  if (!overrides.size) return computed;
  return computed.map((label, i) =>
    overrides.has(i) ? overrides.get(i)! : label,
  );
}
